import classNames from "classnames";

export default function Input({ value, onChange, placeholder, label, error }) {
  const inputGroupClass = classNames("flex-1  mr-0 md:mr-6");

  const inputClass = classNames(
    "text-xl",
    "w-full h-16 p-4",
    "outline-none border-2 border-white focus:border-blue rounded"
  );
  return (
    <div className={inputGroupClass}>
      <input
        className={inputClass}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {error && <div className="text-red mt-2 px-4 text-md">{error}</div>}
    </div>
  );
}
